import React from 'react'
import BookingProducts from '../../BookingProducts/BookingProducts'
import BookingFlowTotal from '../../BookingFlow/BookingFlowTotal'
import ReservationBuilderActions from '../actions/ReservationBuilderActions'
import DateHelper from '../../DateHelper/DateHelper'

export default class ReservationBuilderAddOnsStep extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <BookingProducts
          add_on_products={this.props.products}
          onChangeAddOns={ReservationBuilderActions.changeAddOns}
          onChangeReservationSegmentId={ReservationBuilderActions.changeAddOnsReservationSegmentId}
          reservation_segments={this.props.reservation.reservation_segments}
          reservation_segment_id={this.props.add_ons_reservation_segment_id}
          totalComponent={
            <div className="BookingFlow reservation-builder-products-booking-total">
              <div className="BookingTotal">
                  <BookingFlowTotal {...this.props}
                                    reservation_builder={true}
                                    reservation_segments={this.props.reservation ? this.props.reservation.reservation_segments : []}
                                    add_ons={this.props.add_ons}
                                    date_format={DateHelper.rubyToDateFNS(this.props.date_format)}
                                    number_format={this.props.numberFormat} />
              </div>
            </div>
           }
           cart={this.props.add_ons}
           {...this.props}
        />
      </div>
    );
  }

};
